import { useAuthorityContext } from 'Services/common/Features/Authority/Context/authorityContext'
import { FORM_FIELD_DEFAULT_MIN_WIDTH } from 'Util/constants'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { t } from 'ttag'

interface PTAFormFieldProps {
  value: string | undefined
  onChange: (value: string | undefined) => void
  required?: boolean
  displayEmptyFirstOption?: boolean
}

export default function PTAFormField({
  value,
  onChange,
  required = true,
  displayEmptyFirstOption
}: Readonly<PTAFormFieldProps>) {
  const { codespaces } = useAuthorityContext()

  return (
    <FormControl sx={{ minWidth: FORM_FIELD_DEFAULT_MIN_WIDTH }} size="small" required={required}>
      <InputLabel size="small" shrink={displayEmptyFirstOption}>{t`Authority`}</InputLabel>
      <Select
        name="pta"
        required={required}
        size="small"
        displayEmpty={displayEmptyFirstOption}
        label={t`Authority`}
        value={value ?? ''}
        onChange={e => onChange(e.target.value || undefined)}
        sx={{ backgroundColor: 'background.default' }}
      >
        {displayEmptyFirstOption && <MenuItem value="">{t`Not selected`}</MenuItem>}
        {(codespaces ?? []).map(codespace => (
          <MenuItem key={codespace.codespace_id} value={codespace.codespace_id}>
            {codespace.description}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
